import React, { useState, useEffect, useContext} from "react";
import { useHistory, useLocation } from "react-router-dom";
import { contentContext } from "../../context/contentContext";

const Sidebar = () => {
    const location = useLocation();
    const history = useHistory();
    const { pathname } = location;

       const { setShowPopup, setSelectedOptions, setMultiSelectFields, setActiveFieldsObj, setActiveMenuObj,
            setSelectedOptionsClientName, setSearchPayload, setInitialCategoriesData1, toggleMenu, setToggleMenu, GetTimeActivity,userData, setUserData} = useContext(contentContext)
    

    const [isActive, setIsActive] = useState("dashboard");

    useEffect(() => {
        if (pathname.includes("dashboard")) {
            setIsActive("dashboard");
        } else if (pathname.includes("answers")) {
            setIsActive("answers");
        } else if (pathname.includes("reports")) {
            setIsActive("reports");
        }
    }, [pathname]);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        history.push("/admin");
    };

    const handleMenuClick = (value) => {
        // console.log("Clicked menu item:", value);
        setIsActive(value);
        setToggleMenu(false)
        setTimeout(() => {
            if (value === "dashboard") {
                history.push("/admin/dashboard");
            } else if (value === "answers") {
                history.push("/admin/answers");
            } else if (value === "reports") {
                history.push("/admin/reports");
            }
        }, 0);
    };

    // console.log('toggleMenu ', toggleMenu)

    return (
        <div className={toggleMenu ? `quiz-page-side vertical-menu menu-show` : `quiz-page-side vertical-menu`}>
            <div data-simplebar className="h-100">
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        <li onClick={() => handleMenuClick("dashboard")}>
                            <a className={`waves-effect ${isActive === "dashboard" ? "active" : ""}`}>
                                <i className="bx bxs-help-circle"></i>
                                <span>Quiz</span>
                            </a>
                        </li>
                        <li onClick={() => handleMenuClick("answers")}>
                            <a className={`waves-effect ${isActive === "answers" ? "active" : ""}`}>
                                <i className="bx bxs-comment-detail"></i>
                                <span>Answers</span>
                            </a>
                        </li>
                        <li onClick={() => handleMenuClick("reports")}>
                            <a className={`waves-effect ${isActive === "reports" ? "active" : ""}`}>
                                <i className="bx bxs-report"></i>
                                <span>Reports</span>
                            </a>
                        </li>
                        <li onClick={handleLogout}>
                            <a className="waves-effect">
                                <i className="bx bx-exit"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <p className="activity_time">Action: {localStorage.getItem("timeActivity")}</p>
            </div>
        </div>
    );
};

export default Sidebar;
